<template>
    <div class="page-container" v-loading="exportLoading" element-loading-text="导出中....." element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-card class="card-top" shadow="hover">
            <div class="card-actions">
                <el-form :inline="true" :model="searchForm" size="small" @submit.native.prevent>
                    <el-form-item label="身份证">
                        <el-input v-model="searchForm.customId" placeholder="请输入身份证号" clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch">查询</el-button>
                        <el-button @click="handleReset">重置</el-button>
                        <el-button type="success" :loading="exportLoading" @click="handleExport">导出</el-button>
                    </el-form-item>
                </el-form>
                <div class="time-statistics">
                    <el-form :inline="true" size="small">
                        <el-form-item label="统计时间">
                            <el-date-picker
                                v-model="timeRange"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :default-time="['00:00:00', '23:59:59']"
                                @change="handleTimeChange"
                                :picker-options="{
                                    shortcuts: [{
                                        text: '今天',
                                        onClick(picker) {
                                            const end = new Date();
                                            const start = new Date();
                                            start.setHours(0, 0, 0, 0);
                                            end.setHours(23, 59, 59, 999);
                                            picker.$emit('pick', [start, end]);
                                        }
                                    }]
                                }"
                            />
                        </el-form-item>
                        <el-form-item>
                            <span class="statistics-text">验证人数：<span class="count">{{ verifiedCount }}</span></span>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </el-card>
        <el-card class="card-table" shadow="hover">
            <el-table :data="records" border stripe style="width: 100%;" size="small" height="500px">
                <el-table-column prop="deviceId" label="设备Id" align="center" />
                <el-table-column prop="personName" label="姓名" align="center" />
                <el-table-column prop="customId" label="身份证" align="center" />
                <el-table-column prop="verifyStatus" label="验证状态" align="center">
                    <!-- <template slot-scope="scope">
                        <el-tag :type="scope.row.verifyStatus === 'SUCCESS' ? 'success' : 'danger'">
                            {{ scope.row.verifyStatus === 'SUCCESS' ? '验证成功' : '验证失败' }}
                        </el-tag>
                    </template> -->
                </el-table-column>
                <el-table-column prop="personType" label="人脸类型" align="center">
                    <!-- <template slot-scope="scope">
                        <el-tag :type="scope.row.personType === 'COACH' ? 'primary' : 'warning'">
                            {{ scope.row.personType === 'COACH' ? '教练' : '学员' }}
                        </el-tag>
                    </template> -->
                </el-table-column>
                <el-table-column prop="recognitionTime" label="核验时间" align="center" />
                <el-table-column prop="picData" label="人脸照片" align="center" width="120">
                    <template slot-scope="scope">
                        <div class="photo-cell">
                            <el-image
                                v-if="scope.row.picData"
                                :src="scope.row.picData"
                                :preview-src-list="[scope.row.picData]"
                                fit="cover"
                                class="table-photo"
                            />
                            <span v-else style="color: #ccc;">无</span>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="操作" align="center" width="160">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                        <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <div class="table-pagination">
                <el-pagination background layout="prev, pager, next" :total="total" :page-size="size"
                    :current-page="page" @current-change="handlePageChange" />
            </div>
        </el-card>

    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'FaceRecognitionManage',
    data() {
        return {
            records: [],
            total: 0,
            page: 1,
            size: 20,
            searchForm: {
                customId: '',
            },
            timeRange: [], // 默认时间范围，在created钩子中初始化
            verifiedCount: 0, // 新增验证人数
            exportLoading: false // 全页面导出加载状态
        }
    },
    methods: {
        async fetchRecords() {
            try {
                const params = {
                    customId: this.searchForm.customId,
                    page: this.page,
                    size: this.size
                };
                const res = await axios.get('/api/face-recognition-records', { params });
                this.records = res.data.content || [];
                this.total = res.data.totalElements || 0;
            } catch (e) {
                this.$message.error('获取人脸识别记录失败');
            }
        },
        handleSearch() {
            this.page = 1;
            this.fetchRecords();
        },
        handleReset() {
            this.searchForm = {
                customId: '',
            };
            this.page = 1;
            this.fetchRecords();
        },
        handlePageChange(val) {
            this.page = val;
            this.fetchRecords();
        },
        handleView(row) {
            // 查看详情逻辑
            console.log('查看记录:', row);
        },
        handleDelete(row) {
            // 删除记录逻辑
            this.$confirm('确认删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    await axios.delete(`/api/face-recognition-records/${row.id}`);
                    this.$message.success('删除成功');
                    this.fetchRecords();
                } catch (e) {
                    this.$message.error('删除失败');
                }
            });
        },
        handleTimeChange(val) {
            // 时间范围变化时，重新获取统计人数
            this.fetchVerifiedCount();
        },
        formatDateTime(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        getDefaultTimeRange() {
            const today = new Date();
            const startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
            const endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
            return [
                this.formatDateTime(startTime),
                this.formatDateTime(endTime)
            ];
        },
        async fetchVerifiedCount() {
            try {
                let startTime, endTime;
                
                if (this.timeRange && this.timeRange.length === 2) {
                    // 确保时间格式正确，转换为 yyyy-MM-dd HH:mm:ss 格式
                    if (this.timeRange[0] instanceof Date) {
                        startTime = this.formatDateTime(this.timeRange[0]);
                    } else {
                        startTime = this.timeRange[0];
                    }
                    
                    if (this.timeRange[1] instanceof Date) {
                        endTime = this.formatDateTime(this.timeRange[1]);
                    } else {
                        endTime = this.timeRange[1];
                    }
                }
                
                const params = {
                    startTime: startTime,
                    endTime: endTime
                };
                
                const res = await axios.get('/api/face-recognition-records/count-verified', { params });
                console.log("🚀 ~ fetchVerifiedCount ~ res:", res)
                this.verifiedCount = res.data || 0;
            } catch (e) {
                this.$message.error('获取验证人数失败');
            }
        },
        async handleExport() {
            // 校验必填参数
            if (!this.timeRange || this.timeRange.length !== 2) {
                this.$message.warning('请选择统计时间范围');
                return;
            }
            try {
                this.exportLoading = true;
                
                let startTime, endTime;
                if (this.timeRange[0] instanceof Date) {
                    startTime = this.formatDateTime(this.timeRange[0]);
                } else {
                    startTime = this.timeRange[0];
                }
                
                if (this.timeRange[1] instanceof Date) {
                    endTime = this.formatDateTime(this.timeRange[1]);
                } else {
                    endTime = this.timeRange[1];
                }

                const params = {
                    startTime: startTime,
                    endTime: endTime,
                };

                const res = await axios.get('/api/face-recognition-records/export', {
                    params,
                    responseType: 'blob'
                });

                // 创建下载链接
                const blob = new Blob([res.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `人脸识别记录_${startTime.split(' ')[0]}_${endTime.split(' ')[0]}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                this.$message.success('导出成功');
            } catch (e) {
                console.error('导出失败:', e);
                this.$message.error('导出失败');
            } finally {
                this.exportLoading = false;
            }
        }
    },
    mounted() {
        this.fetchRecords();
        this.fetchVerifiedCount(); // 组件挂载时也获取一次统计人数
        // 放大本页图片预览的初始显示尺寸
        document.body.classList.add('face-viewer-large');
    },
    beforeDestroy() {
        document.body.classList.remove('face-viewer-large');
    },
    created() {
        // 在created钩子中初始化默认时间范围
        this.timeRange = this.getDefaultTimeRange();
    }
}
</script>

<style lang="scss" scoped>
.page-container {
    padding: 24px 18px 0 18px;
    background: #f6f8fa;
    min-height: 100%;
}

.card-top {
    margin-bottom: 18px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.card-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.time-statistics {
    margin-top: 12px;
    padding-left: 10px; /* Align with form items */
}

.statistics-text {
    font-size: 14px;
    color: #606266;
    .count {
        font-weight: bold;
        color: #409eff;
    }
}

.card-table {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.el-table {
    font-size: 15px;
    border-radius: 6px;
    overflow: hidden;
}

.table-pagination {
    margin-top: 18px;
    text-align: right;
}

.table-photo {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    object-fit: cover;
    cursor: zoom-in;
}

.photo-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.image-preview-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.preview-image {
    max-width: 100%;
    max-height: 400px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style> 

<style lang="scss">
/* 仅在人脸识别页面时放大图片预览初始尺寸 */
.face-viewer-large .el-image-viewer__img {
    height: 50vh;
    width: auto;
    max-height: 85vh;
}
</style>